import { render, staticRenderFns } from "./addDialog.vue?vue&type=template&id=0fd80e71&scoped=true&"
import script from "./addDialog.vue?vue&type=script&lang=ts&"
export * from "./addDialog.vue?vue&type=script&lang=ts&"
import style0 from "./addDialog.vue?vue&type=style&index=0&id=0fd80e71&lang=scss&scoped=true&"
import style1 from "./addDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd80e71",
  null
  
)

export default component.exports